import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";
import Grid from "../../../lib/components/grid";
import { GridColumns } from "./gridsetup";
import { getFinalByIdent } from "../../../lib/api/consolidation";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      width: "800px",
    },
  });

type Props = {
  finalRemittanceId: number;
} & WithStyles<typeof styles>;

class ProducerAdvanceInfoUnstyled extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  state = {
    data: [],
    loading: true,
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({ loading: true });
    const resp = await getFinalByIdent(this.props.finalRemittanceId);
    this.setState({ loading: false, data: resp });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Grid loading={this.state.loading} data={this.state.data} GridColumns={GridColumns} clearFilters={"producerfinalinfo"} />
      </div>
    );
  }
}

export default withStyles(styles)(ProducerAdvanceInfoUnstyled);
